@@ -0,0 +1,125 @@
<template>
  <v-dialog max-width="500px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Worker Kind ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="ID:" v-model.number="model.id" hide-details/>
          </v-col>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              label="Name:"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col>
            <v-text-field label="Order:" v-model.number="model.order" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <v-text-field
              label="Key:"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
            <v-col cols="12" md="6" sm="6">
                <v-select
                    label="Group"
                    item-text="text"
                    item-value="value"
                    :items="list"
                    v-model.number="model.group"
                ></v-select>
            </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" sm="6">
            <v-checkbox
                v-model="model.hasMenu"
                label="Has Menu"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row dense>
          <v-expansion-panels focusable>
            <r-maps-panel :model="model" />
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
      <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import { WorkerKind } from "@/modules/redactor/models/worker/WorkerKind";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RAuthorize from "@/modules/redactor/views/common/r-authorize";
import RMapsPanel from "@/modules/redactor/views/utils/r-maps-panel.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";
import {MapAddonGroupModel} from "@/modules/redactor/models/map-addon/core/MapAddonGroupModel";

export default {
  name: "r-worker-kind-dialog",
  components: {RPreviewDialog, RMapsPanel, RAuthorize},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new WorkerKind(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    list(){
      return Array.from(WorkerKind.GROUPS, ([key, value]) => ({ text: value, value: key }));
    },
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorkerKind();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, WorkerKind)
        .then((result) => {
          Object.assign(this.model, result);
        })
        .catch((e) => {
          this.$alert("Failed to parse config!" + e.message);
        });
    }
  }
}
</script>
No newline at end of file
